import CallToAction from "../components/CallToAction";
import Chicago from "../components/Chicago";
import CustomersSay from "../components/CustomersSay";
import Specials from "../components/Specials";

export default function Home() {
  return (
    <>
      <CallToAction />
      <Specials />
      <CustomersSay />
      <Chicago />
    </>
  );
}
